import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';

function useSpotTransferModal() {
  const { user } = useStorage();
  const storage = useStorage();
  const { t } = useTranslation();
  const { swal } = useSwal({ storage });

  async function fire(spot) {
    let text = t('spot-transfer-modal.by-waiter');

    if (user?.name != null) {
      text = t('spot-transfer-modal.by-waiter.with-name', { name: user.name });
    }

    await swal.fire({
      title: spot.name,
      text,
      icon: 'success',
      confirmButtonText: t('ok'),
    });
  }

  return fire;
}

export { useSpotTransferModal };
